import React, { Component, Fragment } from "react"
import modalIcon from "../../../assets/images/testIcon.svg"
import Async from "react-select"
import Field from "../../Common/Field/Field"
import Button from "../../Buttons/Button"
import ModuleHeader from "../ModuleHeader"
import TimerModule from "../TimerModule"
import ButtonIcon from "../../Costing/Button/ButtonIcon"

export default class CuttingModule extends Component {
  state = {
    _id: "",
    cutting: {},
    STATUS: [],
    CUTTINGTYPE: [],
    disabled: false,
    sample: {}
  }

  componentWillMount() {
    const {
      _id,
      cutting,
      STATUS,
      CUTTINGTYPE,
      disabled,
      assignedToList,
      cuttingProcess,
      sample
    } = this.props

    let data = sample.data
    data = data.map(x => x.size && ({ label: x.size }) || 0)

    this.setState({
      _id,
      cutting,
      cuttingProcess,
      STATUS,
      CUTTINGTYPE,
      disabled,
      assignedToList,
      sample: data
    })
  }

  componentWillReceiveProps(nextProps) {
    const {
      _id,
      cutting,
      STATUS,
      CUTTINGTYPE,
      disabled,
      assignedToList,
      cuttingProcess,
      sample
    } = nextProps

    let data = sample.data
    data = data.map(x => x.size && ({ label: x.size }) || 0)

    this.setState({
      _id,
      cutting,
      cuttingProcess,
      STATUS,
      CUTTINGTYPE,
      disabled,
      assignedToList,
      sample: data
    })
  }

  render() {
    const { cutting, STATUS, CUTTING } = this.state
    const { permissions } = this.props
    return (
      <div
        class="card-filter meeting-min-con"
        id="cutting"
        style={{ marginBottom: ".5%" }}
      >
        <div class="col-md-12">
          <ModuleHeader
            header={"Cutting"}
            onClick={this.onOpenModal}
            _id={this.state._id}
            moduleName={"cutting"}
            process={this.state.cuttingProcess}
            updateModulesMain={this.props.updateModulesMain}
            disabled={this.state.disabled}
            statusList={STATUS}
          />
          <div class="col-md-12" style={{ paddingBottom: "1%" }}>
            <form name="cuttingForm">
              <div class="col-md-12 no-padding">
                <div class="col-md-12 no-padding">
                  {/* <div class="col-md-2 step-one pl-0">
                              <div class="form-group no-padding">
                                <label for="ref-no">Assigned To</label>
                                <br />
                                <div class="custom-async-select">

                                <Async
                                    name="assignedTo"
                                    value={cutting.assignedTo}
                                    // onInputChange={this.getDoneBy}
                                    // onChange={e =>
                                    //   this.changeAssignedTo(e, "patternAssignedTo")
                                    // }
                                    placeholder="Find Assigned To"
                                    options={this.state.assignedToList}
                                    disabled = {true}
                                />
                                </div>
                              </div>
                            </div> */}
                  <div class="col-md-2 step-one pl-0">
                    <div class="form-group no-padding">
                      <label for="ref-no">Cutting Master Name</label>
                      <div class="custom-async-select">
                        <Async
                          name="cuttingMaster"
                          value={cutting.cuttingMasterName}
                          //   onInputChange={e =>
                          //     this.getPatternMaster(e, "cuttingMaster")
                          //   }
                          onChange={e =>
                            this.props.updateCutting("cuttingMasterName", e)
                          }
                          placeholder="Cutting master Name"
                          options={this.state.assignedToList}
                          disabled={this.state.disabled}
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 step-one pl-0">
                    <Field
                      isFormGroup={true}
                      inputType="select"
                      inputName="cuttingType"
                      value={cutting.cuttingType}
                      label={"Cutting type "}
                      options={this.state.CUTTINGTYPE}
                      onChange={this.props.updateCutting}
                      disabled={this.state.disabled}
                    />
                  </div>
                  <div class="col-md-2 step-one pl-0">
                    <Field
                      isFormGroup={true}
                      inputType="select"
                      inputName="size"
                      value={cutting.size}
                      label={"Size "}
                      options={this.state.sample}
                      onChange={this.props.updateCutting}
                      disabled={this.state.disabled}
                    />
                  </div>
                   <div class="col-md-2 step-one pl-0">
                    <Field
                      isFormGroup={true}
                      inputType="select"
                      inputName="approvalStatus"
                      label={"Approval Status "}
                      value={cutting.approvalStatus}
                      options={[
                        {
                          label: "approved",
                          value: "approved"
                        },
                        {
                          label: "pending",
                          value: "pending"
                        },
                        {
                          label: "rejected",
                          value: "rejected"
                        }
                      ]}
                      onChange={this.props.updateCutting}
                      disabled={this.state.disabled}
                    />
                  </div>
                  {/* <div class="col-md-2 step-one pl-0">
                                <Field
                                    isFormGroup={true}
                                    inputType="select"
                                    inputName="status"
                                    value={cutting.status}
                                    options={this.state.STATUS}
                                    onChange={this.props.updateCutting}
                                    index ={index}
                                    label = {"Status "}
                                    disabled={this.state.disabled}
                                />
                            </div> */}
                  {/* <div class="col-md-2 step-one pl-0">
                              <Field
                                isFormGroup={true}
                                inputType="date"
                                inputName="ETA"
                                label="ETA"
                                index ={index}
                                value={cutting.ETA}
                                onChange={this.props.updateCutting}
                                disabled={this.state.disabled}
                              />
                            </div>

                            <div class="col-md-2 step-one">
                              <Field
                                isFormGroup={true}
                                inputType="date"
                                inputName="completedDate"
                                label="Date Completed"
                                index ={index}
                                value={cutting.completedDate}
                                onChange={this.props.updateCutting}
                                disabled={this.state.disabled}
                              />
                            </div> */}
                </div>
                {/* <div class="col-md-1 pull-right">
                            <a
                              className={
                                index === 0
                                  ? "btn-floating btn-small waves-effect waves-light green pull-right"
                                  : "btn-floating btn-small waves-effect waves-light red pull-right del-tr-btn"
                              }
                              onClick={e =>
                                this.changeCount(index, "cuttingCount")
                              }
                            >
                              <i class="material-icons">
                                {index === 0 ? "add" : "clear"}
                              </i>
                            </a>
                          </div> */}
              </div>
              <div className="col-md-12">
                <div
                  className="inline-center"
                  style={{ width: "7%", padding: "5px" }}
                >
                  <label>Logs</label>
                  {!this.state.disabled &&
                    (permissions.create || permissions.edit) && (
                      <ButtonIcon
                        buttonType="add"
                        addRemoveFunc={() => this.props.addCuttingLog()}
                      />
                    )}
                </div>
              </div>
              {cutting.logs.map((log, i) => {
                return (
                  <div class="col-md-12 no-padding" key={i}>
                    <TimerModule
                      time={log.timeIn}
                      buttonName={"time in"}
                      updatePatternCheck={() =>
                        this.props.updateCuttingCheck("timeIn", i)
                      }
                      disabled={this.state.disabled}
                    />
                    <TimerModule
                      time={log.timeOut}
                      buttonName={"time out"}
                      updatePatternCheck={() =>
                        this.props.updateCuttingCheck("timeOut", i)
                      }
                      disabled={this.state.disabled}
                    />
                    <div class="col-md-2 step-one pl-0">
                      <Field
                        isFormGroup={true}
                        inputType="time"
                        maxlength={23}
                        inputName="breakTime"
                        label="Break Time (Duration)"
                        value={log.breakTime}
                        onChange={(name, value) =>
                          this.props.updateCuttingLog(name, value, i)
                        }
                        disabled={this.state.disabled}
                      />
                    </div>
                    <div class="col-md-2 step-one pl-0">
                      <Field
                        isFormGroup={true}
                        inputType="text"
                        inputName="reason"
                        label="Reason"
                        value={log.reason}
                        onChange={(name, value) =>
                          this.props.updateCuttingLog(name, value, i)
                        }
                        disabled={this.state.disabled}
                      />
                    </div>
                    <div class="col-md-1 step-one pl-0">
                      {!this.state.disabled &&
                        (permissions.create || permissions.edit) && (
                          <ButtonIcon
                            buttonType="clear"
                            addRemoveFunc={() => this.props.removeCuttingLog(i)}
                          />
                        )}
                    </div>
                  </div>
                )
              })}
              <div class="col-md-12 no-padding pl-0">
                <div class="col-md-10 step-one pl-0">
                  <Field
                    isFormGroup={true}
                    inputType="textarea"
                    inputName="comments"
                    value={cutting.comments}
                    label="comments"
                    onChange={this.props.updateCutting}
                    disabled={this.state.disabled}
                  />
                </div>
              </div>
              {!this.state.disabled &&
                (permissions.create || permissions.edit) && (
                  <div class="col-md-12 px-2 text-center profile-btn">
                    <Button
                      buttonName={"save"}
                      onClick={e => this.props.createCutting(e)}
                    />
                    <Button
                      buttonName={"Complete"}
                      onClick={e => this.props.completeCutting(e)}
                    />
                  </div>
                )}
            </form>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SampleRequest/CuttingModule/index.js